import Box from "@mui/material/Box"
import Chip from "@mui/material/Chip"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"

import ContextMenu from "../ContextMenu"
import { Stack } from "@mui/material"
import { triggerConditions, triggerTypes } from "../ModalAutomation"

function AutomationBox({
    name,
    hooks = [],
    actions = [],
    executionCounting,
    handleChangeActivation,
    handleEdit,
    isActive,
    handleDelete,
}) {
    // const data = [
    //     { day: "2025-05-03", value: 1 },
    //     { day: "2025-05-06", value: 2 },
    // ]

    // const percentage = 7.2

    // const isPositive = percentage >= 0
    const exampleHook = hooks[0]

    const keywords = exampleHook?.keywords || []

    const actionsMessage =
        actions.length === 1
            ? `Uma ação`
            : !actions.length
              ? "Nenhuma ação"
              : `${actions.length} ações`

    const triggersMessage =
        hooks.length === 1
            ? `um gatilho`
            : !hooks.length
              ? "nenhum gatilho"
              : `${hooks.length} gatilhos`

    return (
        <Paper sx={{ mt: 2 }}>
            <Box
                padding={2}
                display="flex"
                alignItems="center"
                position="relative"
            >
                <Box
                    flexBasis="90%"
                    display="flex"
                    flexDirection="column"
                    alignItems="start"
                >
                    <Typography variant="h6">{name}</Typography>
                    <Typography variant="body2">{`${actionsMessage} e ${triggersMessage}`}</Typography>

                    {exampleHook && (
                        <div
                            style={{
                                marginTop: 4,
                                marginBottom: 4,
                                display: "flex",
                                gap: 2,
                            }}
                        >
                            <Stack>
                                <Typography>
                                    {triggerTypes[exampleHook.triggerType]}
                                </Typography>

                                <Box display="flex" gap={1}>
                                    <Typography>
                                        {
                                            triggerConditions[
                                                exampleHook.triggerCondition
                                            ]
                                        }
                                    </Typography>
                                    {!!exampleHook.keywords &&
                                        keywords.map((item) => {
                                            return (
                                                <Chip
                                                    size="small"
                                                    key={item}
                                                    label={item}
                                                />
                                            )
                                        })}
                                </Box>
                            </Stack>
                        </div>
                    )}

                    <div
                        style={{
                            marginTop: 4,
                            marginBottom: 4,
                            display: "flex",
                            gap: 2,
                        }}
                    >
                        <Chip
                            size="small"
                            color={isActive ? "success" : "default"}
                            label={isActive ? `Ativo` : `Inativo`}
                        />
                        {/* <Chip
                            size="small"
                            label={`${executionCounting} execuções`}
                        /> */}
                    </div>
                </Box>
                <Box flexBasis="10%">
                    <Box width="100%" sx={{ mt: 2, height: 60 }}>
                        <Typography variant="h3">
                            {executionCounting}
                        </Typography>
                        <Typography>Execuções</Typography>
                        {/* <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={data}>
                                <XAxis dataKey="day" hide />
                                <Tooltip
                                    cursor={{ fill: "transparent" }}
                                    formatter={(value) => [
                                        `${value}`,
                                        "Negociações",
                                    ]}
                                    labelFormatter={(label) => {
                                        const parsedDate = parseISO(label)
                                        return format(parsedDate, "dd MMM", {
                                            locale: ptBR,
                                        })
                                    }}
                                    position={{
                                        y: -50,
                                        x: -20,
                                    }}
                                />
                                <Bar
                                    dataKey="value"
                                    fill={
                                        isPositive
                                            ? [colors.green[500]]
                                            : colors.red[500]
                                    }
                                    radius={[4, 4, 0, 0]}
                                />
                            </BarChart>
                        </ResponsiveContainer> */}
                    </Box>
                </Box>

                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                    }}
                >
                    <ContextMenu
                        options={[
                            {
                                label: isActive ? "Desativar" : "Ativar",
                                handler: handleChangeActivation,
                            },
                            {
                                label: "Editar",
                                handler: handleEdit,
                            },
                            // {
                            //     label: "Duplicar",
                            //     handler: handleDuplicate,
                            // },
                            {
                                label: "Excluir",
                                handler: handleDelete,
                            },
                        ]}
                    />
                </Box>
            </Box>
        </Paper>
    )
}

export default AutomationBox
